import { pg3ApiClient } from '../index'
import { NewsUpdatesApiResponse } from '../../model/NewsUpdatesApiResponse'
import { CancelableRequestProducer } from '../common/types'

export const fetchNews = (data: any): CancelableRequestProducer<NewsUpdatesApiResponse[]> => {
  return pg3ApiClient.get<NewsUpdatesApiResponse[]>('/news', {
    params: { ...data },
  })
}